import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import FileList from "./Pages/FileList";
import Photos from "./Pages/Photos";
import Layout from "./Component/Layout";
import Trash from "./Pages/Trash";
import Assets from "./Pages/Assets";
import Design from "./Pages/Design";
import Videos from "./Pages/Videos";
import Audio from "./Pages/Audio";
import ShareWithMe from "./Pages/ShareWithMe";
import Recent from "./Pages/Recent";
import MyFolder from "./Pages/MyFolder";
import OpendedFolder from "./Component/OpendedFolder";
import { FileProvider } from "./context/FileContext";
import LoginPage from "./Component/LoginPage";
import User from "./Pages/User";
import Company from "./Pages/Company";
import Members from "./Pages/Members";
import Settings from "./Pages/Settings";
import Starred from "./Pages/Starred";
import SafeFolder from "./Pages/SafeFolder";
import MyDrive from "./Pages/MyDrive";
import Products from "./Pages/Products";
import Employee from "./Pages/Employee";
import Client from "./Pages/Client";
import General from "./Component/General";
import UserPermission from "./Component/User-permission";

const App = () => {
  const [layoutType, setLayoutType] = useState("Default");

  return (
    <FileProvider>
      <BrowserRouter>
        <Routes>
          {/* Layout is used as a wrapper for all the routes */}
          <Route path="/" element={<Layout layoutType={layoutType} />}>
            <Route index element={<Home />} />
            <Route path="myDrive" element={<MyDrive />} />
            <Route path="photos" element={<Photos />} />
            <Route path="fileList" element={<FileList />} />
            <Route path="client/user" element={<User />} />
            <Route path="client/company" element={<Company />} />
            <Route path="audios" element={<Audio />} />
            <Route path="videos" element={<Videos />} />
            <Route path="design" element={<Design />} />
            <Route path="assets" element={<Assets />} />
            <Route path="myfolder" element={<MyFolder />} />
            <Route path="sharewithme" element={<ShareWithMe />} />
            <Route path="folder/:id" element={<OpendedFolder />} />
            <Route path="recent" element={<Recent />} />
            <Route path="trash" element={<Trash />} />
           
            <Route path="starred" element={<Starred />} />
            <Route path="members" element={<Members />} />
            <Route path="safeFolder" element={<SafeFolder />} />
            <Route path="products" element={<Products />} />
            <Route path="employee" element={<Employee />} />
            <Route path="client" element={<Client />} />

            {/*  <Route path="settings" element={<Settings />} >
             <Route path="" element={<General />}/>
             <Route path="" element={<UserPermission />}/>
             <Route path="" element */}

            
          </Route>
        </Routes>
      </BrowserRouter>
    </FileProvider>
  );
};

export default App;
